import {Component, Input, OnInit, Output, EventEmitter, SecurityContext} from '@angular/core';
import {endOfDay, differenceInDays} from 'date-fns';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {JobsDataService} from '../../../modules/jobs/jobs-data.service';
import {UserDataService} from '../../../modules/auth/user-data.service';
import {CompanyDataService} from '../company-account/company-data.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { E } from '@angular/cdk/keycodes';



@Component({
    selector: 'app-job-details',
    templateUrl: './job-details.component.html',
    styleUrls: ['./job-details.component.scss']
})
export class JobDetailsComponent implements OnInit {

    formResponse: boolean;
    formSent: boolean;

    statusChanged: boolean;
    statusSend: boolean;
    statusFail: boolean;

    companyLoaded: boolean;
    companyPageLink: string;
    companyData: any;
    jobId: number;
    job: any = [];
    jobLoaded = false;
    userApplied = false;
    title = 'Reprezentant vanzari Agribusiness';
    type = 'Full Time';
    location = 'Bucuresti';
    postedDaysAgo: number;
    postedOn = new Date(2021, 0, 20);
    expirationDate = new Date(2022, 0, 20);
    image = '/assets/img/jobs/job-details-img.png'
    salary = '2.400 - 3.000 / luna';
    description = 'The argument.....';
    secondDescription = 'The argument.....';
    employerOffer = 'Bla bla bla';

    favJob: string;
    favJobsArray: any = [];
    isJobFav: boolean;

    skills = ['Microsoft', 'Autocad', 'Adobe', 'Comunicare', 'Electric', 'Legume', 'Proiecte', 'Lucru in echipa', 'Inginerie'];

    company: any = [];
    userIsAuthor = false;
    applicationId: string;
    currentUserID: string;
    videoLink: string;
    isCandidate: boolean;
    isSuperAdmin: boolean;

    jobLocationLinks = [];

    jobStatus = '';

    @Input() selected: boolean;
    @Output() selectedChange = new EventEmitter<boolean>();

    constructor(private route: ActivatedRoute,
                private router: Router,
                private jobsDataService: JobsDataService,
                private userDataService: UserDataService,
                private companyDataService: CompanyDataService,
                private sanitizer: DomSanitizer) {

    }
    currentUrl: string;

    ngOnInit(): void {
        this.currentUrl = window.location.href;

        this.route.params.subscribe((params: Params) => {
            this.jobId = params.id;
            this.jobsDataService.getCurrentJob(this.jobId).subscribe(jobRes => {
                this.job = jobRes;

                this.companyDataService.getCompanyData(this.job.companyId).subscribe(companyData => {
                    this.companyData = companyData;
                    this.companyPageLink = 'companii/' + this.job.companyId
                    this.companyLoaded = true;
                    console.log(companyData, 'company?')
                })
                console.log(this.job,'job info')

                this.job.city.forEach(value => {
                    this.jobLocationLinks.push('https://www.google.com/maps/embed/v1/place?key=AIzaSyCqCEx844bba80E9ecdIfAg6uB6vlbI0M4&q='+value+',Romania');
                });


                if (!this.job) {
                    this.router.navigate(['/404']);
                }
                this.jobLoaded = true;
                this.videoLink = this.job.videoLink.replace('youtube.com/watch?v=', 'youtube.com/embed/')

                this.currentUserID = this.userDataService.userData.userId;

                this.isSuperAdmin = this.userDataService.userData.roles.includes('ROLE_super_admin');

                if (this.userDataService.userData.roles.includes('ROLE_JobBoardsCandidate')) {
                    this.isCandidate = true;
                }


                if (this.currentUserID === this.job.userId) {
                    this.userIsAuthor = true;
                }


                this.jobsDataService.getFavJobs().subscribe(favJobs => {
                    this.favJobsArray = favJobs;
                    this.isJobFav = this.favJobsArray.includes(this.job.id);
                    this.selected = this.isJobFav;
                })

                this.jobsDataService.applicationStatus(this.jobId).subscribe((status: any) => {
                    if (status.success === true) {
                        this.userApplied = true;
                        this.applicationId = status.reason;
                    }

                })

            }, error => {
            });
        })

        // get difference between post date and today
        this.postedDaysAgo = differenceInDays(endOfDay(new Date()), this.postedOn);
    }

    transformSafe(url: string) : SafeHtml {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }


    // Change Job Status
    changeJobStatus(jobId, jobStatus, userId) {
        if(userId === this.currentUserID){
            this.companyDataService.changeJobStatus(jobId, jobStatus).subscribe(respData => {
                this.statusChanged = true;
                this.statusSend = true;
                window.scrollTo({top:0, behavior: "smooth"});
            })
        }else{
            this.statusChanged = false;
            this.statusFail = true;
            window.scrollTo({top:0, behavior: "smooth"});
        }
    }

    duplicateJob() {
        this.jobsDataService.duplicateJob(this.jobId).subscribe((res: any) => {
            this.formResponse = true;
            this.formSent = true;
            window.scrollTo({top:0, behavior: "smooth"});
            setTimeout(() => {
                // this.router.navigate([`/editare-job/${res.reason}`])
                this.router.navigate([`/joburile-mele`])
            }, 4000)

        }, error => {
            this.formResponse = false;
            this.formSent = true;
        })
    }

    clickMethod() {
        if (confirm('Dezactivati anuntul')) {
        }
    }

    public toggleFav(jobId) {
        this.selected = !this.selected;
        this.selectedChange.emit(this.selected);

        if (this.selected == false) {
            this.jobsDataService.deleteFavJob(jobId).subscribe(respData => {
            })
        } else {
            this.jobsDataService.addToFavorites(jobId).subscribe(respData => {
            }, error => {
                this.router.navigate(['/autentificare']);
            });
        }

    }


}
